import { Reducer } from '@reduxjs/toolkit';

const appPreferencesReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { preferences: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, preferences: payload };
};

export default appPreferencesReducer;
